export const BASE_API_URL = "https://api.diksha.online";
// export const BASE_API_URL = "http://127.0.0.1:8000";
